import { render, staticRenderFns } from "./FooterInformation.vue?vue&type=template&id=492a06e7&scoped=true"
import script from "./FooterInformation.vue?vue&type=script&lang=js"
export * from "./FooterInformation.vue?vue&type=script&lang=js"
import style0 from "./FooterInformation.vue?vue&type=style&index=0&id=492a06e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a06e7",
  null
  
)

export default component.exports